//@formatter:off
/**
 * @ngdoc filter
 * @name default
 * @module portaro.filters
 * @kind function
 *
 * @param {string} input Input string
 * @param {string} default Default value
 *
 * @return {string} String
 *
 * @description
 * If input is falsy or has less than 1 characters, returns defaultly set value.
 *
 * @example
 * <example module="defaultFilterExample" name="defaultFilterExample" frame-no-resize="true">
    <file name="index.html">
        <main ng-init="defaultValue = '---'">
            <div>
                <label for="input">Input value: </label>
                <input id="input" type="text" ng-model="input">
            </div>
           <div>
                <label for="defaultValue">Default value: </label>
                <input id="defaultValue" type="text" ng-model="defaultValue">
            </div>
            <div>
                Output: {{input | default : defaultValue}}
            </div>
        </main>
    </file>
    <file name="script.js">
        angular.module('defaultFilterExample', ['portaro.filters']);
    </file>
 * </example>
 */
 //@formatter:on
export default function defaultFilter() {
    return (obj, dflt) => {
        if (obj && obj.length > 0) {
            return obj;
        }
        return dflt;
    };
}

defaultFilter.filterName = 'default';